import React, {useEffect, useState} from 'react';
import {BootstrapField, BootstrapError} from "../../../helpers/Field";
import * as yup from 'yup';
import {Formik} from "formik";
import {getAppConfiguration, getConfiguration, smtpTest, updateConfiguration} from "../../../requests/ConfigRequests";
import CustomizingPage from "../customizing/CustomizingPage";
import {toast} from 'react-toastify';
import classNames from "classnames";
import {connect} from "react-redux";
import {useIntl, FormattedMessage, IntlShape} from "react-intl";
import {Paper, Tab, Tabs} from "@material-ui/core"
import {EmailConfiguration} from "./email-config/EmailConfiguration";

const schema = (intl: IntlShape) => {
    return yup.object().shape({
        companyName: yup.string().required(),
        applicationUrl: yup.string().required(),
        smtpAddress: yup.string().required(),
        smtpPort: yup.number().required(),
        smtpUseUser: yup.boolean(),
        registrationRequestEmail: yup.string().email(),
        overrideEmail: yup.string().email(),
        // registrationRequestEmailContent: yup.string(),
        // registrationRequestorEmailContent: yup.string(),
        // welcomeEmailContent: yup.string(),
        // resetPasswordEmailContent: yup.string(),
        emailConfirmationContent: yup.string(),
        fromAddress: yup.string().email(),
        fromAddressName: yup.string(),
        smtpUser: yup.string().when('smtpUseUser', {
            is: true,
            then: yup.string().required(),
        }),
        smtpPassword: yup.string().when('smtpUseUser', {
            is: true,
            then: yup.string(),
        })
    });
};

function _EditConfiguration(props) {
    let sapStatusGood = props.sapConfig.statusCode === 200 && props.sapConfig.data.status.message_type === "S";
    const intl = useIntl();
    const f = id => intl.formatMessage({id: id});
    let [config, setConfig] = useState(null);
    let [showConfiguration, setShowConfiguration] = useState(false);
    let [testEmail, setTestEmail] = useState("");
    let [settingsTab, setSettingsTab] = useState(0);
    
    useEffect(() => {
        getConfiguration().then(_ => setConfig(_));
    }, []);

    function handleSettingsTabChange(event, newValue) {
        setSettingsTab(newValue);
    }

    function toggleShowConfiguration() {
        if (showConfiguration) {
            setShowConfiguration(false);
        } else {
            setShowConfiguration(true);
        }
    }

    function sendTestEmail(values) {
        let _testEmail = prompt("Test Email", testEmail);
        if (_testEmail == null) {
            setTestEmail("");
        } else {
            setTestEmail(_testEmail);
            smtpTest({...values, testEmail: _testEmail}).then((message) => {
                alert(message);
            });
        }
    }

    return (
        <div className="container">
            {config && <React.Fragment>
              <Paper square elevation={1}>
                <Tabs
                  value={settingsTab}
                  indicatorColor="primary"
                  textColor="primary"
                  onChange={handleSettingsTabChange}
                  aria-label="disabled tabs example"
                >
                  <Tab label="Configuration"/>
                  <Tab label="Email Templates"/>
                  <Tab label="Sap Details"/>
                </Tabs>
              </Paper>
                {settingsTab == 0 && <Formik
                  validationSchema={schema(intl)}
                  onSubmit={(values, bag) => {
                      bag.setSubmitting(true);
                      updateConfiguration(values).then(() => {
                          toast.success("Configuration Saved", {position: toast.POSITION.TOP_RIGHT});
                          bag.setSubmitting(false);
                      })
                  }}
                  initialValues={config}
                  render={(formProps: any) => <form onSubmit={formProps.handleSubmit}>
                      <div className="row">
                          <div className="col-12 card">


                              <div className={"row"}>
                                  <div className="col-lg-9 col-md-12">
                                      <h4>{f("configuration.sap_connection_status")} {sapStatusGood ? f("configuration.sap_connection_status_good") : f("configuration.sap_connection_status_error")}</h4>
                                      {!sapStatusGood && <div>
                                          {props.sapConfig.statusMessage}<br/>
                                          {props.sapConfig.statusCode === 200 &&
                                          <React.Fragment>{props.sapConfig.data.status.message_type}<br/>
                                              {props.sapConfig.data.status.message_line_string}<br/>
                                          </React.Fragment>}
                                      </div>}
                                  </div>
                              </div>
                              <div className={"row mt-4"}>
                                  <div className="col-lg-9 col-md-12">
                                      <h3>{f("configuration.configuration_title")}</h3>
                                      <div>
                                          <div className={"form-group row"}>
                                              <label
                                                  className="col-4 col-form-label-sm text-secondary bold">{f("configuration.application_url_label")}</label>
                                              <div className="col">
                                                  <BootstrapField name="applicationUrl" placeholder="Application Url"/>
                                                  <BootstrapError name="applicationUrl"/>
                                              </div>
                                          </div>
                                          <div className={"form-group row"}>
                                              <label
                                                  className="col-4 col-form-label-sm text-secondary bold"><FormattedMessage
                                                  id={'configuration.company_name_label'}/></label>
                                              <div className="col">
                                                  <BootstrapField name="companyName"
                                                                  placeholder={intl.formatMessage({id: 'configuration.company_name_label'})}/>
                                                  <BootstrapError name="companyName"/>
                                              </div>
                                          </div>
                                          <h5>{f("configuration.email_configuration")}</h5>
                                          <div className={"form-group row"}>
                                              <label
                                                  className="col-4 col-form-label-sm text-secondary bold">{f("configuration.smtp_address_label")}</label>
                                              <div className="col">
                                                  <BootstrapField name="smtpAddress"
                                                                  placeholder={f("configuration.smtp_address_label")}/>
                                                  <BootstrapError name="smtpAddress"/>
                                              </div>
                                          </div>
                                          <div className={"form-group row"}>
                                              <label
                                                  className="col-4 col-form-label-sm text-secondary bold">{f("configuration.smtp_port_label")}</label>
                                              <div className="col">
                                                  <BootstrapField name="smtpPort"
                                                                  placeholder={f("configuration.smtp_port_label")}/>
                                                  <BootstrapError name="smtpPort"/>
                                              </div>
                                          </div>
                                          <div className={"form-group row"}>
                                              <label
                                                  className="col-4 col-form-label-sm text-secondary bold">{f("configuration.from_address_label")}</label>
                                              <div className="col">
                                                  <BootstrapField name="fromAddress"
                                                                  placeholder={f("configuration.from_address_label")}/>
                                                  <BootstrapError name="fromAddress"/>
                                              </div>
                                          </div>
                                          <div className={"form-group row"}>
                                              <label
                                                  className="col-4 col-form-label-sm text-secondary bold">{f("configuration.from_address_name")}</label>
                                              <div className="col">
                                                  <BootstrapField name="fromAddressName"
                                                                  placeholder={f("configuration.from_address_name")}/>
                                                  <BootstrapError name="fromAddressName"/>
                                              </div>
                                          </div>

                                          {/*Email To Override*/}

                                          <div className={"form-group row"}>
                                              <label
                                                  className="col-4 col-form-label-sm text-secondary bold">{f("configuration.email.test_address_label")}</label>
                                              <div className="col">
                                                  <BootstrapField name="overrideEmail"
                                                      placeholder={f("configuration.email.registration_request_email")} />
                                                  <BootstrapError name="overrideEmail" />
                                                  <p>
                                                      <small>{f("configuration.email.test_request_address_desc")}</small>
                                                  </p>
                                              </div>
                                          </div>

                                          <div className={"form-group form-check"}>
                                              <BootstrapField id="smtpUseUser" name="smtpUseUser"
                                                              placeholder={f("configuration.email_use_auth_user")}
                                                              type={"checkbox"}
                                                              checked={formProps?.values?.smtpUseUser}/>
                                              <label htmlFor="smtpUseUser"
                                                     className="form-check-label">{f("configuration.email_use_auth_user")}</label>
                                          </div>
                                          {formProps?.values?.smtpUseUser && <React.Fragment>
                                            <div className={"form-group row"}>
                                              <label
                                                className="col-4 col-form-label-sm text-secondary bold">{f("configuration.smtp_user_label")}</label>
                                              <div className="col">
                                                <BootstrapField name="smtpUser"
                                                                placeholder={f("configuration.smtp_user_label")}/>
                                                <BootstrapError name="smtpUser"/>
                                              </div>
                                            </div>
                                            <div className={"form-group row"}>
                                              <label
                                                className="col-4 col-form-label-sm text-secondary bold">{f("configuration.smtp_password_label")}</label>
                                              <div className="col">
                                                <BootstrapField name="smtpPassword"
                                                                placeholder={f("configuration.smtp_password_label")}
                                                                type="password"/>
                                                <BootstrapError name="smtpPassword"/>
                                              </div>
                                            </div>
                                          </React.Fragment>
                                          }
                                          <button className={"btn"} onClick={(event) => {
                                              event.preventDefault();
                                              sendTestEmail(formProps.values);
                                          }}>{f("configuration.smtp_test_email_button")}
                                          </button>
                                       
                                          

                                          <h5>{f("configuration.email.registration_request_address_label")}</h5>
                                          <p>
                                              <small>{f("configuration.email.registration_request_address_desc")}</small>
                                          </p>
                                          <div className={"form-group row"}>
                                              <label
                                                  className="col-4 col-form-label-sm text-secondary bold">{f("configuration.email.registration_request_email")}</label>
                                              <div className="col">
                                                  <BootstrapField name="registrationRequestEmail"
                                                                  placeholder={f("configuration.email.registration_request_email")}/>
                                                  <BootstrapError name="registrationRequestEmail"/>
                                              </div>
                                          </div>
                                          <div>
                                              <button className={"btn btn-primary"} type={"submit"}><FormattedMessage
                                                  id={"save"}/></button>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </form>}/>}
                {
                    settingsTab === 1 && <EmailConfiguration/>
                }
                {
                    settingsTab === 2 && <div>
                      <div className="row">
                        <div className="col-12 card">
                          <CustomizingPage/>
                        </div>
                      </div>
                    </div>
                }
            </React.Fragment>
            }
        </div>

    );
}

export default connect<any, any, any, any>((state, props) => {
    return {
        sapConfig: state.app.config.sap,
    }
})(_EditConfiguration);
